import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  CardContent,
  CardHeader,
  Divider,
  ExpansionPanel,
  ExpansionPanelDetails,
  Grid, TextField,
  useTheme
} from '@material-ui/core';
import { ServiceValues } from '../../../../values/ServiceValues';
import { ServiceAxios } from '../../../../services/ServiceEW';
import moment from 'moment';
import CardTotalizacao from '../../../../components/CardTotalizacao';
import DetalhesFiliado from './DetalhesFiliado';
import DateFnsUtils from '@date-io/date-fns';
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { putVisitaFiliado } from '../../../../services/VisitaFiliadoService';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import { useStyles } from '../VisitaFiliadoRegisterDetalhadoPasso2/ModalidadeGeral/ModalidadeGeralStyles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Card from '@material-ui/core/Card';
import clsx from 'clsx';
import List from '@material-ui/core/List';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import ListItem from '@material-ui/core/ListItem';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import ListItemText from '@material-ui/core/ListItemText';
import { getAllInsumos } from '../../../../services/InsumoService';
import { Values } from '../../../../values/Values';
import Autocomplete from '@material-ui/lab/Autocomplete/Autocomplete';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';

const STATUS_VISITANTE = "24e66833-2365-4658-aeea-e9dcecae2a28";

function VisitaFiliadoRegisterDetalhadoPasso3(props) {
  const {
    visitaFiliado,
    setVisitaFiliado,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    setLoading,
    edicao,
    history,
    empresa
  } = props;
  const [dataEntrada, setDataEntrada] = useState(moment(props.visitaFiliado.dataEntrada));
  const [dataSaida, setDataSaida] = useState();
  const [qtdDisparos, setQtdDisparos] = useState(0);
  const [valorDesconto, setValorDesconto] = useState(0);
  const [valorTotal, setValorTotal] = useState(0);
  const [valorSubtotal, setValorSubtotal] = useState(0);
  const [valorHoraClube, setValorHoraClube] = useState(0);
  const theme = useTheme();
  const [refreshState, setRefreshState] = useState(new Date());
  const [expandedInsumosAdicionais, setExpandedInsumosAdicionais] = useState();
  const classes = useStyles();
  const [insumos, setInsumos] = useState([]);

  const [insumoAdicionalSelecionado, setInsumoSelecionadoAdicional] = useState();
  const [modoEdicaoInsumoAdicional, setModoEdicaoInsumoAdicional] = useState(false);
  const [quantidadeSelecionada, setQuantidadeSelecionada] = useState();


  useEffect(() => {
    getValoresVisita();
    getInsumos();
    visitaFiliado.dataSaida = new Date();
    setDataSaida(moment(visitaFiliado.dataSaida));
    setVisitaFiliado(visitaFiliado);

  }, []);


  async function getInsumos() {
    try{
      setLoading(true);
      let retorno = await getAllInsumos(5000, 1);
      if(retorno.isSuccess) {
        setLoading(false);
        setInsumos(retorno.result);
      }
      else{
        setLoading(false);
        setMessageSnack(retorno.message);
        setTypeSnack('error');
        setShowMessageSnack(true);
      }
    }
    catch (e) {
      setLoading(false);
      setMessageSnack(Values.MessageValues.erro_catch);
      setTypeSnack('error');
      setShowMessageSnack(true);
    }
  }


  function getValoresVisita() {
    let totalDesconto = 0;
    let subtotal = 0;
    let totalDisparos = 0;
    for (let i = 0; i < visitaFiliado.visitaFiliadoMods.length; i++){
      totalDesconto += visitaFiliado.visitaFiliadoMods[i].visitaFiliadoDisps[0].desconto;
      subtotal += (visitaFiliado.visitaFiliadoMods[i].visitaFiliadoDisps[0].valorTotal + visitaFiliado.visitaFiliadoMods[i].visitaFiliadoDisps[0].desconto);
      totalDisparos += visitaFiliado.visitaFiliadoMods[i].visitaFiliadoDisps[0].quantidade;

    }
    setValorDesconto(totalDesconto);
    setQtdDisparos(totalDisparos);
    setValorSubtotal(subtotal);
    calcularValorHoraClube();
  }

  function calcularValorHoraClube() {
    if(visitaFiliado.filiado.idFiliacaoStatus === STATUS_VISITANTE){
      let totalClube = calculoHora();
      setValorHoraClube(totalClube < 0 ? 0 : totalClube);
      visitaFiliado.valorHoraClube = totalClube < 0 ? 0 : totalClube;
      setVisitaFiliado(visitaFiliado);
    }
    else {
      visitaFiliado.valorHoraClube = 0;
    }

  }

  function calculoHora() {
    let diferencaHoras = (moment(visitaFiliado.dataSaida).diff(moment(visitaFiliado.dataEntrada), "minutes"))/60;
    return empresa.result.horaEmpresa * Math.ceil(diferencaHoras);
  }

  const handleChangeDataSaida = date => {
    visitaFiliado.dataSaida = moment(date);
    setVisitaFiliado(visitaFiliado);
    calcularValorHoraClube();
    setDataSaida(date);
  };

  async function salvarVisitaFiliadoCompleta() {
    setLoading(true);
    if(!dataSaida){
      setLoading(false);
      setTypeSnack('warning');
      setMessageSnack('Informe a data e hora de saída.');
      setShowMessageSnack(true);
      return;
    }
    if(!dataEntrada){
      setLoading(false);
      setTypeSnack('warning');
      setMessageSnack('Informe a data e hora de entrada.');
      setShowMessageSnack(true);
      return;
    }
    try {
      let valorInsumosAdicionais = 0;
      for(let j = 0; j < visitaFiliado.insumosAdicionais.length; j++){
        valorInsumosAdicionais += parseFloat(visitaFiliado.insumosAdicionais[j].insumo.valorVenda) * visitaFiliado.insumosAdicionais[j].quantidade;
      }
      visitaFiliado.subtotal = valorSubtotal;
      visitaFiliado.descontoTotal = valorDesconto;
      visitaFiliado.valorInsumoAdicional = valorInsumosAdicionais;
      visitaFiliado.valorTotal = (valorSubtotal - valorDesconto) + valorInsumosAdicionais + visitaFiliado.valorHoraClube;
      visitaFiliado.visitaEncerrada = true;
      let result = await putVisitaFiliado(visitaFiliado);
      if (result.isSuccess) {
        setLoading(false);
        history.push('/visita-filiado-list');
      } else {
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(result.message);
        setShowMessageSnack(true);
      }
    } catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(e.toString());
      setShowMessageSnack(true);
    }
  }

  const changeExpansionPanel = panel => (event, isExpanded) => {
    setExpandedInsumosAdicionais(isExpanded ? panel : false);
  };

  function adicionarNovoInsumoOrigemBranco(event) {
    try{
      event.preventDefault();
      let novoInsumoAdicional = {
        idInsumo: null,
        insumo: null,
        quantidade: null,
        modoEdicao: true,
      };
      setModoEdicaoInsumoAdicional(true);
      visitaFiliado.insumosAdicionais.push(novoInsumoAdicional);
      setVisitaFiliado(visitaFiliado);
      setRefreshState(new Date());
    }
    catch (e) {
      setMessageSnack('Ocorreu um erro ao adicionar novo insumo. Contate o suporte');
      setTypeSnack('error');
      setShowMessageSnack(true);
    }

  }

  function removerInsumoOrigem(event, index) {
    try{
      event.preventDefault();
      if (visitaFiliado.insumosAdicionais[index].idVisitaInsumosAdicionais) {
        visitaFiliado.insumosAdicionais[index].deletado = true;
        visitaFiliado.valorInsumoAdicional -= (visitaFiliado.insumosAdicionais[index].insumo.valorVenda * visitaFiliado.insumosAdicionais[index].quantidade);
        setVisitaFiliado(visitaFiliado);
        setRefreshState(new Date());
      }
      else {
        visitaFiliado.valorInsumoAdicional -= (visitaFiliado.insumosAdicionais[index].insumo.valorVenda * visitaFiliado.insumosAdicionais[index].quantidade);
        visitaFiliado.insumosAdicionais.splice(index, 1);
        setVisitaFiliado(visitaFiliado);
        setRefreshState(new Date());
      }
      setInsumoSelecionadoAdicional(null);
      setQuantidadeSelecionada(null);
      setModoEdicaoInsumoAdicional(false);

    }
    catch (e) {
      setMessageSnack('Ocorreu um erro ao remover insumo. Contate o suporte');
      setTypeSnack('error');
      setShowMessageSnack(true);
    }
  }

  function ativarModoEdicaoInsumoOrigem(event, index) {
    try{
      event.preventDefault();
      setInsumoSelecionadoAdicional(visitaFiliado.insumosAdicionais[index].insumo);
      setQuantidadeSelecionada(visitaFiliado.insumosAdicionais[index].quantidade);
      visitaFiliado.insumosAdicionais[index].modoEdicao = true;
      setVisitaFiliado(visitaFiliado);
      setModoEdicaoInsumoAdicional(true);
    }
    catch (e) {
      setMessageSnack('Ocorreu um erro ao colocar insumo em modo edição. Contate o suporte');
      setTypeSnack('error');
      setShowMessageSnack(true);
    }
  }

  function salvarInsumoAdicional(event, index) {
    try{
      event.preventDefault();
      if(!insumoAdicionalSelecionado){
        setMessageSnack('Informe o insumo adicional');
        setTypeSnack('warning');
        setShowMessageSnack(true);
        return
      }
      if(!quantidadeSelecionada){
        setMessageSnack('Informe uma quantidade válida');
        setTypeSnack('warning');
        setShowMessageSnack(true);
        return;
      }
      let novoInsumoOrigem = {
        idVisitaInsumosAdicionais: visitaFiliado.insumosAdicionais[index].idVisitaInsumosAdicionais,
        idInsumo: insumoAdicionalSelecionado.idInsumo,
        insumo: insumoAdicionalSelecionado,
        quantidade: quantidadeSelecionada,
        modoEdicao: false,
        valorUnitario: insumoAdicionalSelecionado.valorVenda
      };
      visitaFiliado.insumosAdicionais[index] = novoInsumoOrigem;
      visitaFiliado.valorInsumoAdicional += parseFloat(insumoAdicionalSelecionado.valorVenda) * quantidadeSelecionada;
      setVisitaFiliado(visitaFiliado);
      setInsumoSelecionadoAdicional(null);
      setQuantidadeSelecionada(null);
      setModoEdicaoInsumoAdicional(false);
      setRefreshState(new Date());
    }
    catch (e) {
      setMessageSnack(e.toString());
      setTypeSnack('error');
      setShowMessageSnack(true);
    }
  }


  return (
    <div>
      <CardHeader
        subheader="Confirme os dados da visita e clique no botão FINALIZAR"
        title="Finalização de visita"
      />
      <CardContent>
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            md={3}
            sm={6}
            xs={12}
          >
            <CardTotalizacao
              backgroundColorIcon={theme.palette.info.main}
              icon={'PlaylistAddCheckIcon'}
              title='SUBTOTAL'
              value={valorSubtotal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
            />
          </Grid>
          <Grid
            item
            md={3}
            sm={6}
            xs={12}
          >
            <CardTotalizacao
              backgroundColorIcon={theme.palette.warning.main}
              icon={'AddShoppingCartIcon'}
              title='INSUMOS ADICIONAIS'
              value={visitaFiliado.valorInsumoAdicional.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
            />
          </Grid>
          <Grid
            item
            md={3}
            sm={6}
            xs={12}
          >
            <CardTotalizacao
              backgroundColorIcon={theme.palette.success.main}
              icon={'TrendingDownIcon'}
              title='DESCONTO'
              value={valorDesconto.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
            />
          </Grid>
          <Grid
            item
            md={3}
            sm={6}
            xs={12}
          >
            <CardTotalizacao
              backgroundColorIcon={theme.palette.white}
              colorIcon={theme.palette.primary.main}
              icon={'AttachMoneyIcon'}
              title='TOTAL'
              value={((valorSubtotal ? valorSubtotal : 0) +
                (visitaFiliado.valorHoraClube  ? visitaFiliado.valorHoraClube : 0) -
                (valorDesconto ? valorDesconto : 0) +
                (visitaFiliado.valorInsumoAdicional ? visitaFiliado.valorInsumoAdicional : 0)).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
              backgroundColorCard={theme.palette.primary.main}
              colorCard={theme.palette.primary.contrastText}
              colorText='inherit'
            />
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
          >
            <DetalhesFiliado
              visitaFiliado={visitaFiliado}
            />
          </Grid>

          <Grid
            item
            md={12}
            xs={12}
          >
            <ExpansionPanel
              expanded={expandedInsumosAdicionais === 'panel1'}
              onChange={changeExpansionPanel('panel1')}
              variant={'elevation'}
            >
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography className={classes.heading}>{"Insumos adicionais"}</Typography>
              </ExpansionPanelSummary>

              <ExpansionPanelDetails>

                <Grid
                  container
                  spacing={2}
                >
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <Typography
                      variant="h5"
                      color="textPrimary"
                      gutterBottom
                      className={clsx({
                        [classes.title]: true
                      })}
                    >
                      Insumos selecionados
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <Button
                      variant="contained"
                      color={'primary'}
                      className={classes.buttonDelete}
                      onClick={e => adicionarNovoInsumoOrigemBranco(e)}
                      startIcon={<AddIcon />}
                    >
                      novo insumo
                    </Button>
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <List dense>
                    {visitaFiliado.insumosAdicionais.map((insumoAdiconal, index) => {
                        if (!insumoAdiconal.deletado) {
                          return (
                            !insumoAdiconal.modoEdicao ?
                              <Grid
                                container
                                spacing={2}
                              >
                                <Grid
                                  item
                                  md={12}
                                  xs={12}
                                >
                                  <ListItem>
                                    <ListItemAvatar>
                                      <Avatar>
                                        <DoubleArrowIcon/>
                                      </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                      primary={
                                        <Grid
                                          container
                                          spacing={0}
                                        >
                                          <Grid
                                            item
                                            md={6}
                                            xs={6}
                                          >
                                            <Typography
                                              variant="h6"
                                              color="textPrimary"
                                              gutterBottom
                                              className={clsx({
                                                [classes.textoPrimarioItens]: true
                                              })}
                                            >
                                              {`Insumo: ${insumoAdiconal.insumo.descricao}`}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      }
                                      secondary={
                                        <Grid
                                          container
                                          spacing={0}
                                        >
                                          <Grid
                                            item
                                            md={6}
                                            xs={12}
                                          >
                                            <Grid
                                              container
                                            >
                                              <Grid
                                                item
                                                md={7}
                                                xs={12}
                                              >
                                                {`Quantidade: ${insumoAdiconal.quantidade}`}
                                              </Grid>
                                            </Grid>
                                            {'Total: R\$ ' + (parseFloat(insumoAdiconal.insumo.valorVenda) * insumoAdiconal.quantidade).toFixed(2)}
                                          </Grid>
                                        </Grid>
                                      }
                                    />
                                    <ListItemSecondaryAction>
                                      <Grid
                                        container
                                      >
                                        <Grid
                                          item
                                          md={6}
                                          xs={12}
                                          className={clsx({
                                            [classes.gridBotoesAcoes]: true
                                          })}
                                        >
                                          {
                                            !modoEdicaoInsumoAdicional &&
                                            <IconButton
                                              edge="end"
                                              onClick={e => removerInsumoOrigem(e, index)}
                                            >
                                              <DeleteIcon fontSize={'small'}/>
                                            </IconButton>
                                          }

                                        </Grid>
                                        <Grid
                                          item
                                          md={6}
                                          xs={12}
                                          className={clsx({
                                            [classes.gridBotoesAcoes]: true
                                          })}
                                        >
                                          {
                                            !modoEdicaoInsumoAdicional &&
                                            <IconButton
                                              edge="end"
                                              onClick={e => ativarModoEdicaoInsumoOrigem(e, index)}
                                            >
                                              <EditIcon fontSize={'small'}/>
                                            </IconButton>
                                          }
                                        </Grid>
                                      </Grid>
                                    </ListItemSecondaryAction>
                                  </ListItem>
                                  <Divider variant="inset" component="li"/>
                                </Grid>
                              </Grid>
                              :
                              <Grid
                                container
                                spacing={2}
                              >
                                <Grid
                                  item
                                  md={12}
                                  xs={12}
                                >
                                  <ListItem>
                                    <ListItemAvatar>
                                      <Avatar>
                                        <DoubleArrowIcon/>
                                      </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                      primary={
                                        <Grid
                                          container
                                          spacing={2}
                                        >
                                          <Grid
                                            item
                                            md={5}
                                            xs={12}
                                          >
                                            <Autocomplete
                                              options={insumos}
                                              getOptionLabel={(insumo) => `${insumo.descricao}`}
                                              id={'insumoSelecionadoOrigem'}
                                              value={insumoAdicionalSelecionado}
                                              openOnFocus
                                              onChange={(e, insumo) => {
                                                e.preventDefault();
                                                setInsumoSelecionadoAdicional(insumo);
                                              }}
                                              renderInput={(params) => <
                                                TextField
                                                {...params}
                                                label="Insumo"
                                                margin="dense"
                                                fullWidth
                                                variant='outlined'
                                              />}
                                            />
                                          </Grid>
                                          <Grid
                                            item
                                            md={4}
                                            xs={12}
                                          >
                                            <CurrencyTextField
                                              label="Quantidade"
                                              variant="outlined"
                                              value={quantidadeSelecionada}
                                              currencySymbol="Quantidade"
                                              outputFormat="number"
                                              decimalCharacter=","
                                              digitGroupSeparator='.'
                                              fullWidth
                                              minimumValue={0}
                                              margin='dense'
                                              onChange={(event, value) => {
                                                setQuantidadeSelecionada(value)
                                              }}
                                            />
                                          </Grid>
                                        </Grid>

                                      }
                                      secondary={'Selecione o insumo'}
                                    />
                                    <ListItemSecondaryAction>
                                      <Grid
                                        container
                                      >
                                        <Grid
                                          item
                                          md={6}
                                          xs={12}
                                          className={clsx({
                                            [classes.gridBotoesAcoes]: true
                                          })}
                                        >
                                          {
                                            modoEdicaoInsumoAdicional &&
                                            <IconButton
                                              edge="end"
                                              onClick={e => removerInsumoOrigem(e, index)}
                                            >
                                              <DeleteIcon fontSize={'small'}/>
                                            </IconButton>
                                          }
                                        </Grid>
                                        <Grid
                                          item
                                          md={6}
                                          xs={12}
                                          className={clsx({
                                            [classes.gridBotoesAcoes]: true
                                          })}
                                        >
                                          {
                                            modoEdicaoInsumoAdicional &&
                                            <IconButton
                                              edge="end"
                                              onClick={e => salvarInsumoAdicional(e, index)}
                                            >
                                              <CheckIcon />
                                            </IconButton>
                                          }
                                        </Grid>
                                      </Grid>
                                    </ListItemSecondaryAction>
                                  </ListItem>
                                </Grid>
                                <Grid
                                  item
                                  md={12}
                                  xs={12}
                                >
                                  <Divider variant="inset" component="li"/>
                                </Grid>
                              </Grid>
                          )
                        }
                      }
                    )}
                  </List>
                  </Grid>
                </Grid>
              </ExpansionPanelDetails>

            </ExpansionPanel>
            </Grid>

          <Grid
            item
            md={12}
            xs={12}
          >
            <ExpansionPanel>
              <ExpansionPanelDetails>
                <Grid
                  container
                  spacing={2}
                >
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                  >
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <Grid container justify="space-around">
                        <DateTimePicker
                          disabled
                          fullWidth
                          inputVariant="outlined"
                          margin='dense'
                          format="dd/MM/yyyy HH:mm"
                          id="date-picker-inline"
                          label="Data entrada"
                          value={dataEntrada}
                          helperText='Data para registro da entrada do filiado.'
                          KeyboardButtonProps={{
                            'aria-label': 'change date',
                          }}
                        />
                      </Grid>
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                  >
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <Grid container justify="space-around">
                        <DateTimePicker
                          fullWidth
                          lang={'pt-BR'}
                          inputVariant="outlined"
                          margin='dense'
                          format="dd/MM/yyyy HH:mm"
                          id="date-picker-inline"
                          label="Data saída"
                          value={dataSaida}
                          onChange={handleChangeDataSaida}
                          helperText='Data para registro de saída do filiado.'
                          KeyboardButtonProps={{
                            'aria-label': 'change date',
                          }}
                        />
                      </Grid>
                    </MuiPickersUtilsProvider>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={3}
                  >
                    <CurrencyTextField
                      label="Valor total hora do clube"
                      helperText='Caso deseje, altere o valor total da hora do clube.'
                      variant="outlined"
                      currencySymbol="R$"
                      minimumValue="0"
                      outputFormat="number"
                      decimalCharacter=","
                      digitGroupSeparator='.'
                      fullWidth
                      margin="dense"
                      value={visitaFiliado.valorHoraClube}
                      onChange={(e, value) => {
                        visitaFiliado.valorHoraClube = value;
                        setVisitaFiliado(visitaFiliado);
                        setRefreshState(new Date());
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={3}
                  >
                    <Button
                      style={{
                        marginTop: 10
                      }}
                      fullWidth
                      color="primary"
                      variant="contained"
                      margin='dense'
                      onClick={e => salvarVisitaFiliadoCompleta()}
                    >
                      Finalizar Visita
                    </Button>
                  </Grid>
                </Grid>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
    </div>
  );
};

VisitaFiliadoRegisterDetalhadoPasso3.propTypes = {
  className: PropTypes.string,
  visitaFiliado: PropTypes.object.isRequired,
  setVisitaFiliado: PropTypes.object.isRequired
};

export default VisitaFiliadoRegisterDetalhadoPasso3;


